export const MATH_OPERATION_SIGN = {
    DIVISION: '/',
    MULTIPLICATION: '*',
    SUBTRACTION: '-',
    ADDITION: '+',
};

export const MATH_OPERATION_SIGNS = Object.values(MATH_OPERATION_SIGN);
